export default __webpack_public_path__ + "static/media/yahooIcon.ae00ef6e.png";